import React, { useState } from 'react';
import CakeOrderForm from '../cakes/CakeOrderForm';
import BreadForm from '../bread/BreadForm';
import RoscaOrderForm from '../roscas/RoscasOrderForm';
import './Common.css';

export default function Create() {
	// Temporary: Default to rosca for Jan 4-6
	const getDefaultFormType = () => {
		const today = new Date();
		const month = today.getMonth(); // 0 = January
		const day = today.getDate();
		if (month === 0 && day >= 4 && day <= 6) {
			return 'rosca';
		}
		return 'cake';
	};

	const [formType, setFormType] = useState(getDefaultFormType);

	const renderForm = () => {
		switch (formType) {
			case 'cake':
				return <CakeOrderForm />;
			case 'bread':
				return <BreadForm />;
			case 'rosca':
				return <RoscaOrderForm />;
			default:
				return <CakeOrderForm />;
		}
	};

	return (
		<div>
			<div className='buttonContainer'>
				<button className={`switchButton ${formType === 'cake' ? 'active' : ''}`} onClick={() => setFormType('cake')}>Pasteles</button>
				<button className={`switchButton ${formType === 'bread' ? 'active' : ''}`} onClick={() => setFormType('bread')}>Panes</button>
				<button className={`switchButton ${formType === 'rosca' ? 'active' : ''}`} onClick={() => setFormType('rosca')}>Roscas</button>
			</div>
			{renderForm()}
		</div>
	);
}
